import script from "./CreateMultiplierModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateMultiplierModal.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__